import React from 'react';

/**
 * Material Symbols Rounded icon
 * size: px number (default 20)
 * fill: 0 (outlined) or 1 (filled)
 * weight: 100-700
 */
export default function MIcon({ name, size = 20, fill = 0, weight = 400, color = 'currentColor', style = {} }) {
  return (
    <span
      className="material-symbols-rounded"
      style={{
        fontSize: size,
        fontVariationSettings: `'FILL' ${fill}, 'wght' ${weight}, 'GRAD' 0, 'opsz' ${size}`,
        color,
        lineHeight: 1,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        userSelect: 'none',
        flexShrink: 0,
        ...style,
      }}
    >
      {name}
    </span>
  );
}
